<app-modal title="Locais" [form]="form" (save)="onSave($event)">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Nome*"
        formControlName="nome"
        maxLength="12"
      ></app-input>
    </div>
  </form>
</app-modal>
